import { render, staticRenderFns } from "./SuppliesCategoryList.vue?vue&type=template&id=1cd2dd72&"
import script from "./SuppliesCategoryList.ts?vue&type=script&lang=js&"
export * from "./SuppliesCategoryList.ts?vue&type=script&lang=js&"
import style0 from "./SuppliesCategoryList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports